import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import { Affix, Col, Container, Content, FlexboxGrid, Header, Input, InputGroup, List, Navbar, Panel, Stack, Table } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { MainLogo } from "../utils/icons";
import { useIsMobile } from "../utils/useIsMobile";
import axios from "axios";
import image from "assets/img/full-screen-image-2.jpg";
import loader from "assets/img/init.svg";
import SearchIcon from '@rsuite/icons/Search';
import r404 from "assets/img/404.svg";
import r403 from "assets/img/403.svg";
import r500 from "assets/img/500.svg";
import r503 from "assets/img/503.svg";
import { useClearCache } from 'react-clear-cache';

const { Column, HeaderCell, Cell } = Table;

function ListView() {
    const site = useSelector(state => state.site);
    const params = useSelector(state => state.params);
    const history = useHistory();
    const [articulos, setArticulos] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [dataArticulos, setDataArticulos] = useState([]);
    const [sortColumn, setSortColumn] = useState();
    const [sortType, setSortType] = useState();
    const [reportTitle, setReportTitle] = useState("");
    const [loadingState, setLoadingState] = useState(0);
    const [currentState, setCurrentState] = useState("buscando catálogo ...");
    const [cookies, setCookie] = useCookies(['uuid']);
    const groupID = useRef(-1);
    const groupType = useRef(-1);
    const dislpayType = useRef(0);
    const screenSize = useIsMobile();
    const [cssLoaded, setCSSLoaded] = useState(true);
    const [filterArticulo, setFilterArticulo] = useState("");
    const [filterGrupo, setFilterGrupo] = useState("");
    const { isLatestVersion, emptyCacheStorage } = useClearCache();

    const handleSortColumn = (sc, st) => {
        if (sc && st) {
            console.log('sorting');
            setArticulos([...articulos].sort((a, b) => {
                let x = a[sortColumn], y = b[sortColumn];
                if (typeof x === 'string')
                    x = x.charCodeAt();
                if (typeof y === 'string')
                    y = y.charCodeAt();
                return sortType === 'asc' ? x - y : y - x;
            }));
        }
        setSortColumn(sc);
        setSortType(st);
    };
    const ImageCell = ({ rowData, dataKey, ...props }) => (
        <Cell {...props} style={{ padding: 0 }}>
            <div className="view-list-image-item">
                <img src={`${site.site.apiServer}/articulo/${rowData[dataKey]}`} width="80" alt="product" />
            </div>
        </Cell>
    );

    useEffect(() => {
        console.log(`screenSize mobile: ${screenSize.isMobile}`);
        if (site.site != null && !screenSize.isMobile) {
            console.log(site.site);
            if (site.site.responsiveType === '1')
                history.push(window.location.pathname.replace('/vl/', '/vc/'));
        }
    }, [screenSize.isMobile, site]);

    useEffect(() => {
        let art = [...dataArticulos];
        if (filterArticulo.length > 0) {
            art = art.filter(i => i.label.toLowerCase().includes(filterArticulo))
        }
        if (filterGrupo.length > 0) {
            if (groupType.current == 0) {
                art = art.filter(i => i.rubro.toLowerCase().includes(filterGrupo))
            } else if (groupType.current == 1) {
                art = art.filter(i => i.subrubro.toLowerCase().includes(filterGrupo))
            }
        }
        setArticulos(art);
    }, [filterArticulo, filterGrupo]);
 
    useEffect(() => {
        console.log('useEffect begin');
        const source = axios.CancelToken.source();
        if (!isLatestVersion) {
            emptyCacheStorage();
            return () => { console.log('useEffect refresh');};
        }
        const uuid = cookies.uuid ? cookies.uuid : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
        if (!cookies.uuid)
            setCookie('uuid', uuid, { path: '/', sameSite: 'none', domain: '.wisesoft.ar', secure: true, expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5)) });

        const fetchData = async () => {
            await axios
                .get(`${site.site.apiServer}/catalogo/view${window.location.pathname}`, { withCredentials: true })
                .then(async (response) => {
                    if (response.data.result) {
                        console.log(response);
                        setCurrentState("iniciando ...");
                        setReportTitle(response.data.name);
                        dislpayType.current = response.data.pl;
                        const group = [], art = response.data.data, grouped = [];
                        groupID.current = -1;
                        if (response.data.groupType === '0' || response.data.groupType === 0) {
                            groupType.current = 0;
                            for (let i = 0; i < art.length; i++)
                                if (group.length === 0 || !group.some(u => u.id === art[i].rubroID))
                                    group.push({ id: art[i].rubroID, name: art[i].rubro.replace(art[i].rubroID, ''), type: 'rubro' });
                            for (let r = 0; r < group.length; r++) {
                                const x = art.filter(a => a.rubroID === group[r].id);
                                grouped.push(...x);
                            }
                        } else if (response.data.groupType === '1' || response.data.groupType === 1) {
                            groupType.current = 1;
                            for (let i = 0; i < art.length; i++)
                                if (group.length === 0 || !group.some(u => u.id === art[i].subrubroID))
                                    group.push({ id: art[i].subrubroID, name: art[i].subrubro.replace(art[i].subrubroID, ''), type: 'subrubro' });
                            for (let r = 0; r < group.length; r++) {
                                const x = art.filter(a => a.subrubroID === group[r].id);
                                grouped.push(...x);
                            }
                        }
                        setGrupos(group);
                        setDataArticulos(grouped);
                        setArticulos(grouped);
                        setLoadingState(1);
                    }
                })
                .catch((e) => {
                    if (e.response && e.response.data && e.response.data.detail === 'NOT_FOUND') {
                        setLoadingState(-1);
                    } else if (e.response && e.response.data && e.response.data.detail === 'EXPIRED') {
                        setLoadingState(-2);
                    } else if (e.response && e.response.data && e.response.data.detail === 'INACTIVE') {
                        setLoadingState(-3);
                    } else {
                        setLoadingState(-4);
                    }
                });
        }

        var head = document.head;
        var default_css = document.createElement("link");
        default_css.type = "text/css";
        default_css.rel = "stylesheet";
        default_css.href = "./defaultVL.css";
        head.appendChild(default_css);

        var custom_css = document.createElement("link");
        custom_css.type = "text/css";
        custom_css.rel = "stylesheet";
        //custom_css.onload = () => setCSSLoaded(true);
        custom_css.href = `${site.site.apiServer}/catalogo/res/vl`;
        head.appendChild(custom_css);

        var fonts_css = document.createElement("link");
        fonts_css.type = "text/css";
        fonts_css.rel = "stylesheet";
        fonts_css.href = `${site.site.apiServer}/catalogo/res/fonts`;
        head.appendChild(fonts_css);
        
        fetchData();
        console.log(screenSize);
        return () => { head.removeChild(default_css); head.removeChild(custom_css); head.removeChild(fonts_css); if (source) source.cancel('change view'); console.log('useEffect end'); }
    }, [site]);

    return (

        <div className="wrapper wrapper-full-page">
            <div className="full-page section-image" data-color="black">
                <Container>
                    {loadingState === 1 && cssLoaded && screenSize.isMobile && (
                        <Panel style={{ borderRadius: 0, margin: 0, backgroundColor: '#fff' }}>
                            <Stack spacing={0} justifyContent="space-between" direction={"column"}>
                                <Stack.Item grow={1}>
                                    <img src={(params.brand && params.brand.logo80) ? params.brand.logo80 : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg=='} style={{ height: 80, verticalAlign: "bottom" }} />
                                    <div className="view-list-logo-text">
                                        <div>{(params.brand && params.brand.name) ? params.brand.name : ''}</div>
                                        <div>{reportTitle}</div>
                                    </div>
                                </Stack.Item>
                            </Stack>
                        </Panel>
                    )}
                    <Content>
                        {(loadingState === 0)&& (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} colspan={24} md={5} style={{ color: "#fff" }}>
                                    <img src={loader} style={{ display: "block", margin: "auto", width: 150 }} alt="loading" />
                                    <h5 style={{ marginTop: 20, fontWeight: "normal", textAlign: "center" }}>{currentState}</h5>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === 1 && !screenSize.isMobile && (
                            <div style={{height: 20}} />
                        )}
                        {(loadingState === 1) && (
                            <Affix>
                                <Panel shaded style={{ marginBottom: 10, borderRadius: screenSize.isMobile? 0 : 6, backgroundColor: '#fff'}}>
                                    <Stack spacing={10} justifyContent="space-between" direction={screenSize.isMobile ? "column" : "row"}>
                                        {!screenSize.isMobile && (
                                            <Stack.Item grow={1}>
                                                <img src={params.brand.logo80} style={{ height: 80, verticalAlign: "bottom" }} />
                                                <div className="view-list-logo-text">
                                                    <div>{params.brand.name}</div>
                                                    <div>{reportTitle}</div>
                                                </div>
                                            </Stack.Item>
                                        )}
                                        <InputGroup size="md" inside style={{ width: 300 }}>
                                            <Input placeholder="Filtrar por artículo" onChange={e => setFilterArticulo(e.toLowerCase())} />
                                            <InputGroup.Button>
                                                <SearchIcon />
                                            </InputGroup.Button>
                                        </InputGroup>
                                        <InputGroup size="md" inside style={{ width: 300 }}>
                                            <Input placeholder={groupType.current === 0 ? 'Filtrar por rubro' : 'Filtrar por subrubro' } onChange={e => setFilterGrupo(e.toLowerCase())} />
                                            <InputGroup.Button>
                                                <SearchIcon />
                                            </InputGroup.Button>
                                        </InputGroup>
                                    </Stack>
                                </Panel>
                            </Affix>
                        )}
                        {(loadingState === 1) && !screenSize.isMobile && (
                            <Panel shaded className="back-image">
                                <Table rowKey="value" autoHeight data={articulos} id="tablePreview" affixHeader virtualized
                                    sortColumn={sortColumn} locale={{ emptyMessage: "No se econtraron resultados...", loading: "Cargando artículos ..." }}
                                    sortType={sortType} rowHeight={80} hover={false}
                                    onSortColumn={handleSortColumn}>
                                    <Column width={80} align="center">
                                        <HeaderCell></HeaderCell>
                                        <ImageCell dataKey="image" />
                                    </Column>
                                    <Column flexGrow={1} sortable>
                                        <HeaderCell>Artículo</HeaderCell>
                                        <Cell dataKey="label">
                                            {rowData => {
                                                return (<>
                                                    <div className="product-label">{rowData.label}</div>
                                                    <div className="product-code">{`${rowData.rubro} / ${rowData.subrubro} / `}<strong>{`cod. ${rowData.value}`}</strong></div>
                                                </>)
                                            }}
                                        </Cell>
                                    </Column>
                                    <Column width={160} sortable>
                                        <HeaderCell align="right">Precio</HeaderCell>
                                        <Cell align="right" dataKey="price">
                                            {rowData => {
                                                return (<>
                                                    <div className="price">{`$${" " + Number(rowData.price).toFixed(2)}`}</div>
                                                    <div className="price-type">{rowData.priceBottom}</div>
                                                </>)
                                            }}
                                        </Cell>
                                    </Column>
                                </Table>
                            </Panel>
                        )}
                        {loadingState === 1 && screenSize.isMobile && (<>
                            <List hover>
                                {articulos.map((item, index) => {
                                    let grupoItem = null;
                                    if (groupType.current === 0 && groupID.current != item.rubroID) {
                                        grupoItem = grupos.find((x) => x.id === item.rubroID);
                                        groupID.current = item.rubroID;
                                    } else if (groupType.current === 1 && groupID.current != item.subrubroID) {
                                        grupoItem = grupos.find((x) => x.id === item.subrubroID);
                                        groupID.current = item.subrubroID;
                                    }
                                    if (dislpayType.current != 0)
                                        return (
                                            <div key={'container_' + index}>
                                                {grupoItem != null && (
                                                    <List.Item key={'header_' + groupID.current} index={index + 10000} className="group-header">
                                                        <FlexboxGrid>
                                                            <FlexboxGrid.Item colspan={5} className="group-header-logo">
                                                                <img src={`${site.site.apiServer}/catalogo/res/logo-header?id=${grupoItem.id}&type=${grupoItem.type}`} width="60" alt="product" loading="lazy" />
                                                            </FlexboxGrid.Item>
                                                            <FlexboxGrid.Item colspan={19} className="group-header-label" >
                                                                <span>{grupoItem.name}</span>
                                                            </FlexboxGrid.Item>
                                                        </FlexboxGrid>
                                                    </List.Item>
                                                )}
                                                <List.Item key={item['value']} index={index + 1}>
                                                    <FlexboxGrid>
                                                        <FlexboxGrid.Item colspan={6} className="product-icon">
                                                            <img src={`${site.site.apiServer}/articulo/${item['image']}`} width="80" height="80" alt="product" loading="lazy" />
                                                        </FlexboxGrid.Item>
                                                        <FlexboxGrid.Item colspan={17} className="product-content">
                                                            <div className="product-content-name">
                                                                <span>{item['label']}</span>
                                                            </div>
                                                            <div className="product-content-price">
                                                                <h3>{site.site.decimalPlaces === 0 ? new Intl.NumberFormat('es-AR', {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                }).format(item['price']) : (Math.round(item['price'] * 100) / 100).toFixed(site.site.decimalPlaces)}</h3>
                                                                <h4>{item['priceBottom']}</h4>
                                                                <span>{`cod ${item['value']}`}</span>
                                                            </div>
                                                        </FlexboxGrid.Item>
                                                        <FlexboxGrid.Item colspan={1}></FlexboxGrid.Item>
                                                    </FlexboxGrid>
                                                </List.Item>
                                            </div>
                                        )
                                    else
                                        return (
                                            <div key={'container_' + index}>
                                                {grupoItem != null && (
                                                    <List.Item key={'header_' + groupID.current} index={index + 10000} className="group-header">
                                                        <FlexboxGrid>
                                                            <FlexboxGrid.Item colspan={5} className="group-header-logo">
                                                                <img src={`${site.site.apiServer}/catalogo/res/logo-header?id=${grupoItem.id}&type=${grupoItem.type}`} width="60" alt="product" loading="lazy" />
                                                            </FlexboxGrid.Item>
                                                            <FlexboxGrid.Item colspan={19} className="group-header-label" >
                                                                <span>{grupoItem.name}</span>
                                                            </FlexboxGrid.Item>
                                                        </FlexboxGrid>
                                                    </List.Item>
                                                )}
                                                <List.Item key={item['value']} index={index + 1} className="no-price">
                                                    <FlexboxGrid>
                                                        <FlexboxGrid.Item colspan={6} className="product-icon no-price">
                                                            <img src={`${site.site.apiServer}/articulo/${item['image']}`} height="80" width="80" alt="product" loading="lazy" />
                                                        </FlexboxGrid.Item>
                                                        <FlexboxGrid.Item colspan={18} className="product-content no-price">
                                                            <div className="product-content-name">
                                                                <span>{item['label']}</span>
                                                            </div>
                                                        </FlexboxGrid.Item>
                                                    </FlexboxGrid>
                                                    <div className="product-code no-price">{`cod ${item['value']}`}</div>

                                                </List.Item>
                                            </div>
                                        )
                                }
                                )}
                            </List>
                        </>)}
                        {loadingState === -1 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r404} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>No se encontró el catálogo solicitado</h4>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === -2 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r403} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>Expiró la vigencia del catálogo solicitado</h4>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === -3 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r503} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>La publicación se encuentra en pausa...</h4>
                                    <h5 style={{ marginTop: 10, textAlign: "center", opacity: .6, fontWeight: "normal" }}>Por favor, intente ingresar nuevamente en unos instantes.</h5>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === -4 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r500} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>Pedimos disculpas, el servidor no está respondiendo...</h4>
                                    <h5 style={{ marginTop: 10, textAlign: "center", opacity: .6, fontWeight: "normal" }}>Por favor, intente ingresar nuevamente en unos instantes.</h5>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                    </Content>
                </Container>
                <div className="full-page-background" style={{ backgroundImage: `url(${image})` }}></div>
            </div>
        </div>

    );
}
export default ListView;